    <div class="w-full h-full">
        <!-- Export icon row -->
        <div class="flex justify-end mb-2 gap-2 w-full px-11 mt-5">
            <span 
                class="material-icons text-black cursor-pointer text-2xl"
                matTooltip="Export to Excel"
                matTooltipClass="custom-orange-tooltip"
                matTooltipPosition="left"
                (click)="print()">
                print
            </span>
        </div>
        <form [formGroup]="form">

            <!-- Row 1: First Name, Middle Name, Last Name -->
            <div class="grid grid-cols-12 gap-3 px-11">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="true">
                        <span class="text-xs w-100-px font-semibold">First Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="firstName"
                            type="text"
                            placeholder="First Name">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="true">
                        <span class="text-xs w-120-px font-semibold">Middle Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="middleName"
                            type="text"
                            placeholder="Middle Name">
                    </div>
                </div>
                <div class="col-span-4" >
                    <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="true">
                        <span class="text-xs w-100-px font-semibold">Last Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="lastName"
                            type="text"
                            placeholder="Last Name">
                    </div>
                </div>
            </div>

            <!-- Row 2: Phone Number, Status, Account Type -->
            <div class="grid grid-cols-12 gap-3 mt-3 px-11">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="true">
                        <span class="text-xs w-120-px font-semibold">Phone Number:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            formControlName="phoneNumber"
                            type="text"
                            placeholder="Phone Number">
                    </div>
                </div>
                <div class="col-span-4">
                    <app-custom-dropdown-v2
                        label="Distributor Type:"
                        [labelWidth]="'100px'"
                        [options]="distributorTypeOptions"
                        [selectedText]="distributorType_text"
                        placeholder="== Select an option =="
                        (selectionChange)="setDistributorType($event.label, $event.value)"
                    >
                    </app-custom-dropdown-v2>
                </div>
                <div class="col-span-4">
                    <app-custom-dropdown-v2
                        label="Status:"
                        [labelWidth]="'60px'"
                        [options]="statusOptions"
                        [selectedText]="statusType_text"
                        placeholder="== Select an option =="
                        (selectionChange)="setStatusType($event.label, $event.value)"
                    >
                    </app-custom-dropdown-v2>
                </div>
            </div>

            <!-- Row 3: Tier (left-aligned, col-span-4) -->
            <div class="grid grid-cols-12 gap-3 mt-3 px-11">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="true">
                        <span class="text-xs w-120-px font-semibold">Assigned By:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            formControlName="assignedBy"
                            type="text"
                            placeholder="Assigned By">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="true">
                        <app-date-input
                            class="w-full text-black"
                            label="Date From:"
                            [parentForm]="form"
                            controlName="dateFrom">
                        </app-date-input>
                    </div>
                </div>

                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full" [appHighlightOnActive]="true">
                        <app-date-input
                            class="w-full text-black"
                            label="Date To:"
                            [parentForm]="form"
                            controlName="dateTo">
                        </app-date-input>
                    </div>
                </div>
            </div>

        </form>

        <!-- Submit Button -->
        <div class="w-full flex items-center justify-center mt-10 mb-4">
            <button
                (click)="submit()"
                class="uppercase custom-btn btn-dark-orange font-bold text-xs px-6 py-2">
                submit
            </button>
        </div>
        <!-- Data Table Section -->
        <div *ngIf="showTable">
            <div *ngIf="submitted">
                <div class="flex flex-col">
                    <div class="flex flex-row justify-between items-center w-full py-2">
                        <app-limit-control
                            [currentLimit]="size"
                            (limitChangeEvent)="onLimitChangeFromComponent($event)"
                        ></app-limit-control>
                        <div class="flex flex-row items-center gap-2 mr-6">
                            <app-search-control
                                [searchPlaceholder]="'Search'"
                                (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
                                (keydownEvent)="keyDownFunction($event)"
                            ></app-search-control>
                            <ng-container *ngIf="getAdminButtonState() as btnState">
                                <button
                                    *ngIf="!btnState.disabled"
                                    (click)="openAddDistributorDialog('regional')"
                                    class="uppercase custom-btn btn-dark-orange font-bold text-xs px-6 py-2">
                                    new regional <br> distributor
                                </button>
                                <span
                                    *ngIf="btnState.disabled"
                                    [matTooltip]="btnState.tooltip"
                                    matTooltipClass="custom-orange-tooltip"
                                    matTooltipPosition="left"
                                    style="display: inline-block; cursor: not-allowed;">
                                    <button
                                        class="uppercase custom-btn btn-dark-orange font-bold text-xs px-6 py-2"
                                        style="opacity:0.4; pointer-events:none;"
                                        disabled>
                                        new regional <br> distributor
                                    </button>
                                </span>
                            </ng-container>
                        </div>
                    </div>
                    <div>
                        <app-data-table
                            [tableSubHeader]="tableSubHeader"
                            [isLoading]="isLoading"
                            [sort_type]="sort_type"
                            (toggleOnSort)="sortList($event.key, $event.type)">
                            <tr class="focus:outline-none text-center" *ngFor="let item of itemLists">
                                <td>{{ item.firstName      | nullWithDefault | titlecase }}</td>
                                <td>{{ item.middleName     | nullWithDefault | titlecase }}</td>
                                <td>{{ item.lastName       | nullWithDefault | titlecase }}</td>
                                <td>{{ item.phoneNumber    | nullWithDefault }}</td>
                                <td>{{ item.email          | nullWithDefault }}</td>
                                <td>{{ item.distributorType| nullWithDefault }}</td>
                                <td>{{ item.status         | nullWithDefault }}</td>
                                <td>{{ item.assignedBy     | nullWithDefault }}</td>
                                <td class="w-150-px">{{ item.assignedDate   | nullWithDefault | asiaDate }}</td>
                                <td>{{ item.modifiedBy     | nullWithDefault }}</td>
                                <td class="w-150-px">{{ item.assignedDate   | nullWithDefault | asiaDate }}</td>

                                <td class="flex flex-row items-center justify-center gap-1">
                                    <ng-container *ngIf="getAdminButtonState() as btnState">

                                        <!-- Enabled/Disabled toggle -->
                                        <ng-container *ngIf="!btnState.disabled; else disabledStatusBtn">
                                            <button
                                                *ngIf="item.status === 'Enabled'"
                                                class="custom-btn power-btn2 active focus:outline-none"
                                                style="width:68px; height:30px; font-size:12px;"
                                                (click)="toggleStatusConfirmation(item)">
                                                Enabled
                                            </button>
                                            <button
                                                *ngIf="item.status === 'Disabled'"
                                                class="custom-btn power-btn2 focus:outline-none"
                                                style="width:68px; height:30px; font-size:12px;"
                                                (click)="toggleStatusConfirmation(item)">
                                                Disabled
                                            </button>
                                        </ng-container>

                                        <ng-template #disabledStatusBtn>
                                            <span
                                                [matTooltip]="btnState.tooltip"
                                                matTooltipClass="custom-orange-tooltip"
                                                matTooltipPosition="left"
                                                style="display: inline-block; cursor: not-allowed;">
                                                <button
                                                    *ngIf="item.status === 'Enabled'"
                                                    class="custom-btn power-btn2 active focus:outline-none"
                                                    style="width:68px; height:30px; font-size:12px; opacity:0.4; pointer-events:none;"
                                                    disabled>
                                                    Enabled
                                                </button>
                                                <button
                                                    *ngIf="item.status === 'Disabled'"
                                                    class="custom-btn power-btn2 focus:outline-none"
                                                    style="width:68px; height:30px; font-size:12px; opacity:0.4; pointer-events:none;"
                                                    disabled>
                                                    Disabled
                                                </button>
                                            </span>
                                        </ng-template>

                                        <!-- Distribution Chain — always visible -->
                                        <button
                                            class="custom-btn action-btns focus:outline-none px-2"
                                            style="width: auto; min-width: 120px; height: 30px; font-size: 12px;"
                                            (click)="viewDistributors(toDistributorTypeKey(item.distributorType), item.accountGuid)">
                                            Distribution Chain
                                        </button>

                                        <!-- New child distributor — admin only -->
                                        <ng-container *ngIf="!btnState.disabled; else disabledAddBtn">
                                            <button
                                                *ngIf="item.distributorType === 'Regional Distributor'"
                                                class="custom-btn btn-dark-orange text-xs py-2 px-2"
                                                style="width:auto; height:30px; min-width: 160px;"
                                                (click)="openAddDistributorDialog('provincial', item.accountGuid)">
                                                New Provincial Distributor
                                            </button>
                                            <button
                                                *ngIf="item.distributorType === 'Provincial Distributor'"
                                                class="custom-btn btn-dark-orange text-xs py-2"
                                                style="width:auto; height:30px; min-width: 90px;"
                                                (click)="openAddDistributorDialog('retailer', item.accountGuid)">
                                                New Retailer
                                            </button>
                                        </ng-container>

                                        <ng-template #disabledAddBtn>
                                            <span
                                                *ngIf="item.distributorType === 'Regional Distributor'"
                                                [matTooltip]="btnState.tooltip"
                                                matTooltipClass="custom-orange-tooltip"
                                                matTooltipPosition="left"
                                                style="display: inline-block; cursor: not-allowed;">
                                                <button
                                                    class="custom-btn btn-dark-orange text-xs py-2"
                                                    style="width:auto; height:30px; min-width: 160px; opacity:0.4; pointer-events:none;"
                                                    disabled>
                                                    New Provincial Distributor
                                                </button>
                                            </span>
                                            <span
                                                *ngIf="item.distributorType === 'Provincial Distributor'"
                                                [matTooltip]="btnState.tooltip"
                                                matTooltipClass="custom-orange-tooltip"
                                                matTooltipPosition="left"
                                                style="display: inline-block; cursor: not-allowed;">
                                                <button
                                                    class="custom-btn btn-dark-orange text-xs py-2 px-2"
                                                    style="width:auto; height:30px; min-width: 90px; opacity:0.4; pointer-events:none;"
                                                    disabled>
                                                    New Retailer
                                                </button>
                                            </span>
                                        </ng-template>

                                        <!-- Remove — admin only -->
                                        <ng-container *ngIf="!btnState.disabled; else disabledRemoveBtn">
                                            <button
                                                class="custom-btn power-btn2 focus:outline-none"
                                                style="width:75px; height:30px; font-size:12px;"
                                                (click)="removeDistributorConfirmation(item)">
                                                <iconify-icon class="trash-icon" icon="tabler:trash"></iconify-icon>
                                                Remove
                                            </button>
                                        </ng-container>

                                        <ng-template #disabledRemoveBtn>
                                            <span
                                                [matTooltip]="btnState.tooltip"
                                                matTooltipClass="custom-orange-tooltip"
                                                matTooltipPosition="left"
                                                style="display: inline-block; cursor: not-allowed;">
                                                <button
                                                    class="custom-btn power-btn2 focus:outline-none"
                                                    style="width:75px; height:30px; font-size:12px; opacity:0.4; pointer-events:none;"
                                                    disabled>
                                                    <iconify-icon class="trash-icon" icon="tabler:trash"></iconify-icon>
                                                    Remove
                                                </button>
                                            </span>
                                        </ng-template>

                                    </ng-container>
                                </td>
                            </tr>
                            <tr *ngIf="!isLoading && itemLists.length === 0">
                                <td [attr.colspan]="tableSubHeader?.length || 12" class="text-center py-4 h-150-px text-gray-500 italic">
                                    <span class="font-semibold text-xs uppercase tracking-wide text-black">No records found</span><br>
                                    <span class="italic text-xs text-black">Try adjusting your search or filter criteria.</span>
                                </td>
                            </tr>
                        </app-data-table>
                    </div>
                    <app-pagination
                        [currentPage]="current_page"
                        [totalPages]="total_pages"
                        backgroundColor="bg-white"
                        [pageSize]="size"
                        [totalItems]="total"
                        (pageChange)="setPage($event)"
                        (previousPage)="prevPage()"
                        (nextPage)="nextPage()"
                        [showTotalEntries]="true">
                    </app-pagination>
                </div>
            </div>
        </div>
    </div>


<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>